window.theme = window.theme || {};

theme.ProductSlider = (function() {
  // Check if we're on a product page
  if (!document.querySelector('[data-section-type="product"]') && 
      !document.querySelector('.template-product')) {
    return {
      filterByVariant: function() {},
      initialize: function() {},
      getState: function() {}
    };
  }

  var currentSlider = null;
  var currentVariant = null;
  var thumbSlider = null;
  var debug = false; // Set this to true to enable logging
  var previousColor = null;
  var currentImageId = null;
  var isInitializingSlider = false; // Track initialization state

  function log() {
    if (debug && console && console.log) {
      console.log.apply(console, arguments);
    }
  }

  // Function to detect if this is a gift card product
  function isGiftCardProduct() {
    var giftCardIndicators = [
      document.querySelector('[data-template="gift-card"]'),
      document.querySelector('[data-template="product.gift-card"]'),
      document.body.classList.contains('template-product-gift-card') ? document.body : null,
      document.querySelector('[data-gift-card-recipient-form]'),
      document.querySelector('.gift-card-recipient-form'),
      (function() {
        var title = document.querySelector('.product__title, h1.product-single__title, .product-title');
        return title && title.textContent.toLowerCase().includes('gift card') ? title : null;
      })(),
      window.location.pathname.includes('/products/gift-card') ? window.location : null
    ].filter(Boolean);

    if (giftCardIndicators.length > 0) {
      log('Gift card product detected via:', giftCardIndicators);
      return true;
    }

    var walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    var node;
    while (node = walker.nextNode()) {
      if (node.textContent.includes('product.gift-card')) {
        log('Gift card product detected via text content:', node.textContent);
        return true;
      }
    }

    return false;
  }

  // Function to show all images without filtering (for gift cards)
  function showAllImages() {
    log('Showing all images for gift card product');
    var state = updateSliderState();
    if (!state) return;

    var mainSlides = Array.from(state.mainSlider.querySelectorAll('.product-main-slide'));
    var thumbItems = Array.from(state.thumbSlider.querySelectorAll('.product__thumb-item'));

    if (!state.mainSlider.originalSlides) {
      state.mainSlider.originalSlides = mainSlides.map(function(slide) {
        return slide.cloneNode(true);
      });
      state.thumbSlider.originalThumbs = thumbItems.map(function(thumb) {
        return thumb.cloneNode(true);
      });
    }

    var sliders = initializeSliders();
    if (!sliders) return;

    var mainFlickity = sliders.mainFlickity;

    createPageDots(state.mainSlider, mainFlickity);

    if (mainSlides.length) {
      mainFlickity.remove(mainSlides);
    }

    state.thumbSlider.innerHTML = '';

    var allSlides = state.mainSlider.originalSlides || mainSlides;
    var allThumbs = state.thumbSlider.originalThumbs || thumbItems;

    allSlides.forEach(function(slide) {
      var newSlide = slide.cloneNode(true);
      var img = newSlide.querySelector('img');
      if (img) {
        img.classList.add('photoswipe__image');
        img.classList.add('js-photoswipe__zoom');
        if (!img.hasAttribute('data-photoswipe-src')) {
          img.setAttribute('data-photoswipe-src', img.src);
        }
        if (!img.hasAttribute('data-photoswipe-width')) {
          img.setAttribute('data-photoswipe-width', img.naturalWidth || 1000);
        }
        if (!img.hasAttribute('data-photoswipe-height')) {
          img.setAttribute('data-photoswipe-height', img.naturalHeight || 1000);
        }
      }
      mainFlickity.append(newSlide);
    });

    var container = state.mainSlider.closest('[data-product-images]');
    if (container) {
      container.setAttribute('data-zoom', 'true');
      container.setAttribute('data-has-slideshow', 'true');
      new theme.Photoswipe(container);
    }

    initializeVideosInSlides(allSlides);
    playVideoOnActiveSlide();

    allThumbs.forEach(function(thumb, index) {
      var newThumb = thumb.cloneNode(true);
      var links = newThumb.querySelectorAll('a');
      links.forEach(function(link) {
        var newLink = link.cloneNode(true);
        link.parentNode.replaceChild(newLink, link);
      });
      newThumb.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (mainFlickity) {
          mainFlickity.select(index, false, true);
          handleThumbScroll(state.thumbSlider, index);
        }
      });
      state.thumbSlider.appendChild(newThumb);
    });

    mainFlickity.on('change', function(index) {
      handleThumbScroll(state.thumbSlider, index);
      var activeSlide = mainFlickity.selectedElement;
      if (!activeSlide) return;
      var video = activeSlide.querySelector('video.product__video');
      if (!video) return;
      var wrapper = video.closest('.product__video-wrapper');
      video.play().then(function() {
        if (wrapper) wrapper.classList.add('video-interactable');
      }).catch(function() {
        video.setAttribute('controls', '');
        if (wrapper) wrapper.classList.add('video-interactable');
      });
    });

    initThumbSlider(state.mainSlider, state.thumbSlider);

    mainFlickity.reloadCells();
    mainFlickity.resize();
    mainFlickity.select(0, false, true);
    mainFlickity.updateDraggable();
    mainFlickity.reposition();
    mainFlickity.options.draggable = allSlides.length > 1;
    mainFlickity.updateDraggable();

    log('All images shown for gift card product');
  }

  function updateSliderState() {
    log('updateSliderState called');
    var mainSlider = document.querySelector("[data-product-photos]");
    var thumbSliderEl = document.querySelector("[data-product-thumbs]");
    if (!mainSlider || !thumbSliderEl) {
      log('Could not find sliders:', { mainSlider, thumbSliderEl });
      return null;
    }
    return {
      mainSlider: mainSlider,
      thumbSlider: thumbSliderEl,
      flickityInstance: mainSlider.flickity ? mainSlider.flickity : null
    };
  }

  function destroyThumbSlider() {
    log('destroyThumbSlider - Starting destruction');
    if (!thumbSlider) {
      log('No thumbSlider instance exists to destroy');
      return;
    }

    var sliderElement = thumbSlider.element;
    if (!sliderElement || !sliderElement.parentNode) {
      log('Slider element or its parent no longer exists');
      thumbSlider = null;
      return;
    }

    var viewportElement = thumbSlider.viewport;
    if (!viewportElement || !sliderElement.contains(viewportElement)) {
      log('Viewport element is not a child of slider');
      thumbSlider = null;
      return;
    }

    try {
      log('Attempting to destroy thumbSlider');
      thumbSlider.destroy();
      log('Successfully destroyed thumbSlider');
    } catch (error) {
      log('Error destroying thumbSlider:', error);
    }

    thumbSlider = null;
  }

  function initThumbSlider(mainSlider, thumbSliderEl) {
    log('initThumbSlider called');
    destroyThumbSlider();

    thumbSlider = new Flickity(thumbSliderEl, {
      asNavFor: mainSlider,
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      cellAlign: 'left',
      draggable: true,
      vertical: true,
      verticalCells: true
    });

    log('Thumb slider initialized');
  }

  function doesImageBelongToColor(imgUrl, colorName) {
    var cleanImgUrl = imgUrl.toLowerCase().split('?')[0];
    var colorParts = colorName.toLowerCase().trim().split(' ');

    return colorParts.some(function(part) {
      if (part === '-' || part.includes('$') || part.includes('.') || part.length <= 1) {
        return false;
      }
      return cleanImgUrl.includes('_' + part + '_') ||
             cleanImgUrl.includes('/' + part + '_') ||
             cleanImgUrl.includes('_' + part + '-') ||
             cleanImgUrl.includes('_' + part + '.') ||
             cleanImgUrl.includes('-' + part + '_') ||
             cleanImgUrl.includes('-' + part + '-') ||
             cleanImgUrl.includes('-' + part + '.');
    });
  }

  function handleThumbScroll(sliderEl, index) {
    if (!sliderEl) return;

    var allThumbs = sliderEl.querySelectorAll('.product__thumb-item');
    if (!allThumbs.length) return;

    allThumbs.forEach(function(t, i) {
      var indicator = t.querySelector('.thumb-indicator');
      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'thumb-indicator';
        indicator.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 2px solid #000; opacity: 0; pointer-events: none; z-index: 1;';
        t.style.position = 'relative';
        t.appendChild(indicator);
      }
      indicator.style.opacity = i === index ? '1' : '0';
    });

    var activeThumb = allThumbs[index];
    if (activeThumb) {
      var thumbRect = activeThumb.getBoundingClientRect();
      var containerRect = sliderEl.getBoundingClientRect();
      if (thumbRect.top < containerRect.top || thumbRect.bottom > containerRect.bottom) {
        var scrollTop = activeThumb.offsetTop - (sliderEl.clientHeight / 2) + (activeThumb.clientHeight / 2);
        sliderEl.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });
      }
    }
  }

  function getCurrentSelectedColor() {
    var colorOption = document.querySelector('[data-option-index="0"] [checked], [data-option-index="0"] .active') ||
                     document.querySelector('.single-option-selector__radio:checked') ||
                     document.querySelector('[data-index="option1"]:checked');

    if (colorOption) {
      return colorOption.value || colorOption.getAttribute('data-value');
    }

    var colorSelect = document.querySelector('[data-option-index="0"] select');
    if (colorSelect) {
      return colorSelect.value;
    }

    return null;
  }

  function initializeColorTracking() {
    var initialColor = getCurrentSelectedColor();
    previousColor = initialColor;
  }

  initializeColorTracking();

  document.addEventListener('DOMContentLoaded', initializeColorTracking);

  function filterByVariant(color, variant, eventVariantFeaturedMediaId) {
    log('filterByVariant called with params:', {
      color: color,
      variantTitle: variant ? variant.title : 'no variant',
      featuredMediaId: eventVariantFeaturedMediaId
    });

    if (isGiftCardProduct()) {
      log('Gift card product detected - skipping filterByVariant');
      return;
    }

    if (!previousColor) {
      previousColor = getCurrentSelectedColor();
    }

    if (previousColor === color && !eventVariantFeaturedMediaId) {
      log('Early return: color unchanged (' + previousColor + ' === ' + color + ') and no featured media to reorder');
      if (variant && variant.featured_media) {
        currentImageId = variant.featured_media.id;
      }
      return;
    }

    if (previousColor === color && eventVariantFeaturedMediaId) {
      log('Color unchanged but continuing to reorder featured media...');
    }

    previousColor = color;

    if (!color || !variant) {
      log('Missing color or variant:', { color, variant });
      return;
    }

    var state = updateSliderState();
    if (!state) {
      log('Could not get slider state');
      return;
    }

    var colorNames = color.toLowerCase().split('/');
    log('Filtering by colors:', colorNames);

    var variantFeaturedMediaId = eventVariantFeaturedMediaId;

    var mainSlides = Array.from(state.mainSlider.querySelectorAll('.product-main-slide'));
    var thumbItems = Array.from(state.thumbSlider.querySelectorAll('.product__thumb-item'));

    if (!state.mainSlider.originalSlides) {
      state.mainSlider.originalSlides = mainSlides.map(function(slide) {
        return slide.cloneNode(true);
      });
      state.thumbSlider.originalThumbs = thumbItems.map(function(thumb) {
        return thumb.cloneNode(true);
      });
      log('Stored original slides and thumbs');
    }

    var flickity = Flickity.data(state.mainSlider);
    if (!flickity) {
      log('Creating new Flickity instance');
      flickity = new Flickity(state.mainSlider, {
        dragThreshold: 25,
        adaptiveHeight: true,
        avoidReflow: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: 'left',
        contain: true
      });
    }

    createPageDots(state.mainSlider, flickity);

    if (mainSlides.length) {
      flickity.remove(mainSlides);
      log('Removed all slides from main slider');
    }

    state.thumbSlider.innerHTML = '';
    log('Cleared thumb slider');

    var matchedSlides = [];
    var matchedThumbs = [];

    (state.mainSlider.originalSlides || mainSlides).forEach(function(slide, index) {
      var videoWrapper = slide.querySelector('.product__video-wrapper');
      var video = slide.querySelector('video');
      var isVideoSlide = !!(videoWrapper || video);

      // Always include video slides — skip color matching entirely
      if (isVideoSlide) {
        var newSlide = slide.cloneNode(true);
        var slideImg = newSlide.querySelector('img');
        if (slideImg) {
          slideImg.classList.add('photoswipe__image');
          slideImg.classList.add('js-photoswipe__zoom');
          if (!slideImg.hasAttribute('data-photoswipe-src')) {
            slideImg.setAttribute('data-photoswipe-src', slideImg.src);
          }
          if (!slideImg.hasAttribute('data-photoswipe-width')) {
            slideImg.setAttribute('data-photoswipe-width', slideImg.naturalWidth || 1000);
          }
          if (!slideImg.hasAttribute('data-photoswipe-height')) {
            slideImg.setAttribute('data-photoswipe-height', slideImg.naturalHeight || 1000);
          }
        }
        matchedSlides.push(newSlide);
        var thumbSource = state.thumbSlider.originalThumbs ? state.thumbSlider.originalThumbs[index] : thumbItems[index];
        if (thumbSource) {
          matchedThumbs.push(thumbSource.cloneNode(true));
        }
        return;
      }

      // Image-only slides — filter by color
      var img = slide.querySelector('img');
      if (!img) return;

      var imgUrl = img.getAttribute('src');
      var belongsToVariant = colorNames.some(function(colorName) {
        return doesImageBelongToColor(imgUrl, colorName);
      });

      if (belongsToVariant) {
        var newSlide = slide.cloneNode(true);
        var newImg = newSlide.querySelector('img');
        if (newImg) {
          newImg.classList.add('photoswipe__image');
          newImg.classList.add('js-photoswipe__zoom');
          if (!newImg.hasAttribute('data-photoswipe-src')) {
            newImg.setAttribute('data-photoswipe-src', newImg.src);
          }
          if (!newImg.hasAttribute('data-photoswipe-width')) {
            newImg.setAttribute('data-photoswipe-width', newImg.naturalWidth || 1000);
          }
          if (!newImg.hasAttribute('data-photoswipe-height')) {
            newImg.setAttribute('data-photoswipe-height', newImg.naturalHeight || 1000);
          }
        }
        matchedSlides.push(newSlide);
        var thumbSource = state.thumbSlider.originalThumbs ? state.thumbSlider.originalThumbs[index] : thumbItems[index];
        if (thumbSource) {
          matchedThumbs.push(thumbSource.cloneNode(true));
        }
      }
    });

    log('Matched slides and thumbs:', {
      slides: matchedSlides.length,
      thumbs: matchedThumbs.length
    });

    // Reorder slides to put featured media first
    if (variantFeaturedMediaId && matchedSlides.length > 0) {
      log('🔍 Looking for featured media ID:', variantFeaturedMediaId);

      var featuredIndex = -1;
      for (var i = 0; i < matchedThumbs.length; i++) {
        var thumbLink = matchedThumbs[i].querySelector('a[data-id]');
        var thumbId = thumbLink ? thumbLink.getAttribute('data-id') : null;
        log('  Checking thumb', i, 'ID:', thumbId);

        if (thumbLink && String(thumbId) === String(variantFeaturedMediaId)) {
          featuredIndex = i;
          log('  ✅ FOUND featured media at index:', i);
          break;
        }
      }

      if (featuredIndex > 0) {
        var featuredSlide = matchedSlides.splice(featuredIndex, 1)[0];
        var featuredThumb = matchedThumbs.splice(featuredIndex, 1)[0];
        matchedSlides.unshift(featuredSlide);
        matchedThumbs.unshift(featuredThumb);
      } else if (featuredIndex === 0) {
        log('✅ Featured media already at index 0');
      } else {
        log('❌ Featured media NOT FOUND in matched slides');
      }
    }

    if (matchedSlides.length > 0) {
      flickity.append(matchedSlides);
      log('Appended slides to main slider');

      var container = state.mainSlider.closest('[data-product-images]');
      if (container) {
        container.setAttribute('data-zoom', 'true');
        container.setAttribute('data-has-slideshow', 'true');
        new theme.Photoswipe(container);
      }

      initializeVideosInSlides(matchedSlides);
      playVideoOnActiveSlide();

      matchedThumbs.forEach(function(thumb, index) {
        var links = thumb.querySelectorAll('a');
        links.forEach(function(link) {
          var newLink = link.cloneNode(true);
          link.parentNode.replaceChild(newLink, link);
        });

        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (flickity) {
            flickity.select(index, false, true);
            handleThumbScroll(state.thumbSlider, index);
          }
        });

        state.thumbSlider.appendChild(thumb);
      });
      log('Appended thumbs to thumb slider with click handlers');

      initThumbSlider(state.mainSlider, state.thumbSlider);

      flickity.on('change', function(index) {
        handleThumbScroll(state.thumbSlider, index);
        var activeSlide = flickity.selectedElement;
        if (!activeSlide) return;
        var video = activeSlide.querySelector('video.product__video');
        if (!video) return;
        var wrapper = video.closest('.product__video-wrapper');
        video.play().then(function() {
          if (wrapper) wrapper.classList.add('video-interactable');
        }).catch(function() {
          video.setAttribute('controls', '');
          if (wrapper) wrapper.classList.add('video-interactable');
        });
      });

      flickity.reloadCells();
      flickity.resize();
      flickity.updateDraggable();
      flickity.reposition();
      flickity.options.draggable = matchedSlides.length > 1;
      flickity.updateDraggable();

      flickity.select(0, false, true);
      handleThumbScroll(state.thumbSlider, 0);

      log('Updated main slider configuration');
    }
  }

  function handleInitialVariant() {
    log('handleInitialVariant called');
    var state = updateSliderState();
    if (!state) return;

    var initialColorOption = document.querySelector('[data-option-index="0"] [checked], [data-option-index="0"] .active');
    if (initialColorOption) {
      log('Found initial color option:', initialColorOption);
      var initialColor = initialColorOption.value || initialColorOption.getAttribute('data-value');
      log('Initial color:', initialColor);
      filterByVariant(initialColor, { featured_media: { preview_image: { src: '' } } }, null);
    } else {
      log('No initial color option found');
    }
  }

  function initializeSlider(container) {
    log('initializeSlider called');
    var state = updateSliderState();
    if (!state) return;

    var sliderOptions = {
      dragThreshold: 25,
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      cellAlign: 'left',
      contain: true,
      on: {
        ready: function() {
          log('Flickity ready event fired');
          handleInitialVariant();
        }
      }
    };

    currentSlider = new theme.Slideshow(state.mainSlider, sliderOptions);
    return currentSlider;
  }

  function extractColorsFromTitle(title) {
    var parts = title.split(' / ');
    if (!parts[0]) return [];
    var colorPart = parts[0];
    var colors = colorPart.split('/').map(function(color) {
      return color.trim();
    });
    log('Extracted colors from title:', colors);
    return colors;
  }

  function initializeSliders() {
    var state = updateSliderState();
    if (!state) return null;

    var mainFlickity = Flickity.data(state.mainSlider);
    if (!mainFlickity) {
      mainFlickity = new Flickity(state.mainSlider, {
        dragThreshold: 25,
        adaptiveHeight: true,
        avoidReflow: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        initialIndex: 0
      });
    }

    if (!thumbSlider) {
      thumbSlider = new Flickity(state.thumbSlider, {
        asNavFor: state.mainSlider,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        draggable: true,
        vertical: true,
        verticalCells: true,
        initialIndex: 0
      });
    }

    setTimeout(function() {
      handleThumbScroll(state.thumbSlider, 0);
      mainFlickity.select(0, false, true);
    }, 100);

    return {
      mainFlickity: mainFlickity,
      thumbSlider: thumbSlider
    };
  }

  function filterInitialImages(colors, initialVariant) {
    log('Filtering initial images for colors:', colors);
    var state = updateSliderState();
    if (!state) return;

    var initialFeaturedMediaId = initialVariant && initialVariant.featured_media ? initialVariant.featured_media.id : null;
    log('Initial load - Featured Media ID:', initialFeaturedMediaId);

    var mainSlides = Array.from(state.mainSlider.querySelectorAll('.product-main-slide'));
    var thumbItems = Array.from(state.thumbSlider.querySelectorAll('.product__thumb-item'));

    if (!state.mainSlider.originalSlides) {
      state.mainSlider.originalSlides = mainSlides.map(function(slide) {
        return slide.cloneNode(true);
      });
      state.thumbSlider.originalThumbs = thumbItems.map(function(thumb) {
        return thumb.cloneNode(true);
      });
    }

    var initialStartingSlide = state.mainSlider.querySelector('.product-main-slide.starting-slide');
    var initialStartingIndex = initialStartingSlide ? Array.from(mainSlides).indexOf(initialStartingSlide) : 0;
    log('Initial starting slide index:', initialStartingIndex);

    var sliders = initializeSliders();
    if (!sliders) return;

    var mainFlickity = sliders.mainFlickity;

    if (mainFlickity) {
      mainFlickity.on('select', function(index) {
        var slide = mainFlickity.selectedElement;
        var img = slide ? slide.querySelector('img') : null;
        var imgSrc = img ? img.src.split('/').pop().split('?')[0] : 'no-image';
        console.log('🎯 FLICKITY SELECT EVENT:', {
          index: index,
          imageName: imgSrc,
          hasStartingSlide: slide ? slide.classList.contains('starting-slide') : false
        });
      });

      mainFlickity.on('change', function(index) {
        var slide = mainFlickity.selectedElement;
        var img = slide ? slide.querySelector('img') : null;
        var imgSrc = img ? img.src.split('/').pop().split('?')[0] : 'no-image';
        console.log('🔄 FLICKITY CHANGE EVENT:', {
          index: index,
          imageName: imgSrc,
          hasStartingSlide: slide ? slide.classList.contains('starting-slide') : false
        });
      });
    }

    if (mainSlides.length) {
      mainFlickity.remove(mainSlides);
    }

    state.thumbSlider.innerHTML = '';

    var matchedSlides = [];
    var matchedThumbs = [];

    (state.mainSlider.originalSlides || mainSlides).forEach(function(slide, index) {
      var videoWrapper = slide.querySelector('.product__video-wrapper');
      var video = slide.querySelector('video');
      var isVideoSlide = !!(videoWrapper || video);

      // Always include video slides — skip color matching entirely
      if (isVideoSlide) {
        var newSlide = slide.cloneNode(true);
        var slideImg = newSlide.querySelector('img');
        if (slideImg) {
          slideImg.classList.add('photoswipe__image');
          slideImg.classList.add('js-photoswipe__zoom');
          if (!slideImg.hasAttribute('data-photoswipe-src')) {
            slideImg.setAttribute('data-photoswipe-src', slideImg.src);
          }
          if (!slideImg.hasAttribute('data-photoswipe-width')) {
            slideImg.setAttribute('data-photoswipe-width', slideImg.naturalWidth || 1000);
          }
          if (!slideImg.hasAttribute('data-photoswipe-height')) {
            slideImg.setAttribute('data-photoswipe-height', slideImg.naturalHeight || 1000);
          }
        }
        matchedSlides.push(newSlide);
        var thumbSource = state.thumbSlider.originalThumbs ? state.thumbSlider.originalThumbs[index] : thumbItems[index];
        if (thumbSource) {
          matchedThumbs.push(thumbSource.cloneNode(true));
        }
        return;
      }

      // Image-only slides — filter by color
      var img = slide.querySelector('img');
      if (!img) return;

      var imgUrl = img.getAttribute('src');
      var belongsToVariant = colors.some(function(colorName) {
        return doesImageBelongToColor(imgUrl, colorName);
      });

      if (belongsToVariant) {
        var newSlide = slide.cloneNode(true);
        var newImg = newSlide.querySelector('img');
        if (newImg) {
          newImg.classList.add('photoswipe__image');
          newImg.classList.add('js-photoswipe__zoom');
          if (!newImg.hasAttribute('data-photoswipe-src')) {
            newImg.setAttribute('data-photoswipe-src', newImg.src);
          }
          if (!newImg.hasAttribute('data-photoswipe-width')) {
            newImg.setAttribute('data-photoswipe-width', newImg.naturalWidth || 1000);
          }
          if (!newImg.hasAttribute('data-photoswipe-height')) {
            newImg.setAttribute('data-photoswipe-height', newImg.naturalHeight || 1000);
          }
        }
        matchedSlides.push(newSlide);
        var thumbSource = state.thumbSlider.originalThumbs ? state.thumbSlider.originalThumbs[index] : thumbItems[index];
        if (thumbSource) {
          matchedThumbs.push(thumbSource.cloneNode(true));
        }
      }
    });

    // Reorder slides to put featured media first
    if (initialFeaturedMediaId && matchedSlides.length > 1) {
      log('🔍 Initial load - Looking for featured media ID:', initialFeaturedMediaId);

      var featuredIndex = -1;
      for (var i = 0; i < matchedThumbs.length; i++) {
        var thumbLink = matchedThumbs[i].querySelector('a[data-id]');
        var thumbId = thumbLink ? thumbLink.getAttribute('data-id') : null;

        if (thumbLink && String(thumbId) === String(initialFeaturedMediaId)) {
          featuredIndex = i;
          log('  ✅ FOUND featured media at index:', i);
          break;
        }
      }

      if (featuredIndex > 0) {
        var featuredSlide = matchedSlides.splice(featuredIndex, 1)[0];
        var featuredThumb = matchedThumbs.splice(featuredIndex, 1)[0];
        matchedSlides.unshift(featuredSlide);
        matchedThumbs.unshift(featuredThumb);
        log('✅ Initial load - Moved featured media to index 0');
      } else if (featuredIndex === 0) {
        log('✅ Initial load - Featured media already at index 0');
      }
    }

    if (matchedSlides.length > 0) {
      mainFlickity.append(matchedSlides);

      var container = state.mainSlider.closest('[data-product-images]');
      if (container) {
        container.setAttribute('data-zoom', 'true');
        container.setAttribute('data-has-slideshow', 'true');
        new theme.Photoswipe(container);
      }

      matchedThumbs.forEach(function(thumb, index) {
        var links = thumb.querySelectorAll('a');
        links.forEach(function(link) {
          var newLink = link.cloneNode(true);
          link.parentNode.replaceChild(newLink, link);
        });

        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (mainFlickity) {
            mainFlickity.select(index, false, true);
            handleThumbScroll(state.thumbSlider, index);
          }
        });

        state.thumbSlider.appendChild(thumb);
      });

      // Combined change handler: thumb scroll + video playback
      mainFlickity.on('change', function(index) {
        handleThumbScroll(state.thumbSlider, index);
        var activeSlide = mainFlickity.selectedElement;
        if (!activeSlide) return;
        var video = activeSlide.querySelector('video.product__video');
        if (!video) return;
        var wrapper = video.closest('.product__video-wrapper');
        video.play().then(function() {
          if (wrapper) wrapper.classList.add('video-interactable');
        }).catch(function() {
          video.setAttribute('controls', '');
          if (wrapper) wrapper.classList.add('video-interactable');
        });
      });

      var existingThumbSlider = Flickity.data(state.thumbSlider);
      if (existingThumbSlider) {
        existingThumbSlider.reloadCells();
        existingThumbSlider.resize();
        existingThumbSlider.reposition();
      }

      initThumbSlider(state.mainSlider, state.thumbSlider);

      mainFlickity.reloadCells();
      mainFlickity.resize();

      var correctSlideIndex = 0;
      if (initialStartingSlide) {
        var originalStartingSlideImg = initialStartingSlide.querySelector('img');
        if (originalStartingSlideImg) {
          var originalSrc = originalStartingSlideImg.getAttribute('src');
          matchedSlides.forEach(function(slide, index) {
            var slideImg = slide.querySelector('img');
            if (slideImg && slideImg.getAttribute('src') === originalSrc) {
              correctSlideIndex = index;
            }
          });
        }
      }

      log('Selecting correct slide index after filtering:', correctSlideIndex);
      console.log('🎯 PRODUCT-SLIDER filterInitialImages: CHANGING SLIDE TO INDEX:', correctSlideIndex);
      mainFlickity.select(correctSlideIndex, false, true);
      mainFlickity.updateDraggable();
      mainFlickity.reposition();

      setTimeout(function() {
        initializeVideosInSlides(matchedSlides);
        playVideoOnActiveSlide();
      }, 150);

      mainFlickity.options.draggable = matchedSlides.length > 1;
      mainFlickity.updateDraggable();

      createPageDots(state.mainSlider, mainFlickity);
    }
  }

  function getCurrentVariantData() {
    var variantSelect = document.querySelector('select[name="id"]');
    var variantInput = document.querySelector('input[name="id"]:checked');

    if (variantSelect) {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var variantId = selectedOption.value;
      var variantTitle = selectedOption.text;
      var colors = extractColorsFromTitle(variantTitle);
      return {
        current_variant_id: variantId,
        title: variantTitle,
        colors: colors
      };
    } else if (variantInput) {
      var variantId = variantInput.value;
      var variantLabel = variantInput.getAttribute('data-variant-title') ||
                        variantInput.closest('label')?.textContent.trim() ||
                        document.querySelector(`label[for="${variantInput.id}"]`)?.textContent.trim();
      var colors = extractColorsFromTitle(variantLabel);
      return {
        current_variant_id: variantId,
        title: variantLabel,
        colors: colors
      };
    }

    return null;
  }

  document.addEventListener('shopify:section:load', function(event) {
    log('shopify:section:load event fired', event);
    if (event.target.querySelector('[data-product-photos]')) {
      initializeSlider();
    }
  });

  document.addEventListener('variant:change', function(event) {
    log('variant:change event fired', event);
    console.log('🔄 PRODUCT-SLIDER variant:change event:', {
      event: event,
      variant: event.detail ? event.detail.variant : null,
      mediaId: event.detail && event.detail.variant && event.detail.variant.featured_media ? event.detail.variant.featured_media.id : null
    });

    if (isGiftCardProduct()) {
      log('Gift card product detected - skipping variant change filtering');
      return;
    }

    var currentVariant = null;
    if (event.detail && event.detail.variant) {
      currentVariant = event.detail.variant;
      log('Using event variant (this is the correct one):', currentVariant);
    } else if (window.theme && window.theme.Product && window.theme.Product.variants && window.theme.Product.variants.currentVariant) {
      currentVariant = window.theme.Product.variants.currentVariant;
      log('Fallback to theme.Product variant:', currentVariant);
    }

    if (currentVariant) {
      var eventVariantFeaturedMediaId = currentVariant && currentVariant.featured_media ? currentVariant.featured_media.id :
                                       (currentVariant && currentVariant.featured_image ? currentVariant.featured_image.id : null);

      if (currentVariant && currentVariant.option1) {
        var color = currentVariant.option1;
        log('About to call filterByVariant with featuredMediaId:', eventVariantFeaturedMediaId);
        filterByVariant(color, currentVariant, eventVariantFeaturedMediaId);

        requestAnimationFrame(function() {
          var state = updateSliderState();
          if (state) {
            var flickity = Flickity.data(state.mainSlider);
            if (flickity) {
              log('🔧 SMOOTH selecting index 0 after variant change');
              flickity.select(0, false, true);
              handleThumbScroll(state.thumbSlider, 0);
            }
          }
        });
      } else {
        log('No color found in variant.option1');
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    log('DOMContentLoaded event fired');

    isInitializingSlider = true;

    setTimeout(function() {
      var mainSlider = document.querySelector('[data-product-photos]');
      if (mainSlider) {
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              var slide = mutation.target;
              if (slide.classList.contains('product-main-slide') && slide.parentNode) {
                var img = slide.querySelector('img');
                var imgSrc = img ? img.src.split('/').pop().split('?')[0] : 'no-image';
                var isVisible = slide.style.display !== 'none' && slide.style.display !== '';
                console.log('👁️ SLIDE VISIBILITY CHANGE:', {
                  slideIndex: Array.from(slide.parentNode.children).indexOf(slide),
                  imageName: imgSrc,
                  isVisible: isVisible,
                  display: slide.style.display,
                  hasStartingSlide: slide.classList.contains('starting-slide')
                });
              }
            }
          });
        });

        observer.observe(mainSlider, {
          attributes: true,
          subtree: true,
          attributeFilter: ['style']
        });

        console.log('👁️ SLIDE VISIBILITY OBSERVER: Started tracking slide visibility changes');
      }
    }, 100);

    var checkSlider = setInterval(function() {
      var state = updateSliderState();
      if (state && state.mainSlider) {
        clearInterval(checkSlider);

        if (isGiftCardProduct()) {
          log('Gift card product detected - showing all images');
          showAllImages();

          setTimeout(function() {
            var mainFlickity = Flickity.data(state.mainSlider);
            if (mainFlickity) {
              console.log('🎯 PRODUCT-SLIDER gift card: CHANGING SLIDE TO INDEX: 0');
              mainFlickity.select(0, false, true);
              handleThumbScroll(state.thumbSlider, 0);
            }
          }, 100);
        } else {
          var variantData = getCurrentVariantData();
          if (variantData && variantData.colors && variantData.colors.length > 0) {
            log('Initial load - filtering for colors:', variantData.colors);

            var initialVariant = null;
            if (window.theme && window.theme.Product && window.theme.Product.variants && window.theme.Product.variants.currentVariant) {
              initialVariant = window.theme.Product.variants.currentVariant;
            }

            filterInitialImages(variantData.colors, initialVariant);

            setTimeout(function() {
              var mainFlickity = Flickity.data(state.mainSlider);
              if (mainFlickity) {
                console.log('🎯 PRODUCT-SLIDER regular product final: CHANGING SLIDE TO INDEX: 0');
                mainFlickity.select(0, false, true);
                handleThumbScroll(state.thumbSlider, 0);
              }
            }, 100);
          }
        }

        setTimeout(function() {
          isInitializingSlider = false;
          log('ProductSlider initialization complete');
        }, 200);
      }
    }, 100);

    setTimeout(function() {
      clearInterval(checkSlider);
    }, 5000);

    window.addEventListener('load', function() {
      setTimeout(function() {
        var thumbsContainer = document.querySelector('.product__thumbs');
        var mainSliderContainer = document.querySelector('.product__main-photos');
        if (thumbsContainer && mainSliderContainer) {
          thumbsContainer.style.visibility = 'visible';
          thumbsContainer.style.opacity = '1';
          mainSliderContainer.style.visibility = 'visible';
          mainSliderContainer.style.opacity = '1';

          var state = updateSliderState();
          if (state && state.thumbSlider) {
            handleThumbScroll(state.thumbSlider, 0);
          }
        }
      }, 100);
    });
  });

  function getCurrentImageId() {
    return currentImageId;
  }

  // Helper to re-initialize videos after slides are changed
  function initializeVideosInSlides(slides) {
    if (window.theme && window.theme.productInstance && typeof theme.Product.prototype.videoSetup === 'function') {
      theme.Product.prototype.videoSetup.call(window.theme.productInstance);
    }
  }

  // Helper to play video on the active slide
  function playVideoOnActiveSlide() {
    var mainSlider = document.querySelector("[data-product-photos]");
    if (!mainSlider) return;
    var activeSlide = mainSlider.querySelector('.product-main-slide.is-selected');
    if (!activeSlide) return;
    var video = activeSlide.querySelector('video.product__video');
    if (!video) return;
    var wrapper = video.closest('.product__video-wrapper');
    video.play().then(function() {
      if (wrapper) wrapper.classList.add('video-interactable');
    }).catch(function() {
      video.setAttribute('controls', '');
      if (wrapper) wrapper.classList.add('video-interactable');
    });
  }

  // Helper to create page dots for the main slider
  function createPageDots(mainSlider, flickityInstance) {
    var existingDots = mainSlider.querySelector('.flickity-page-dots');
    if (existingDots) {
      existingDots.remove();
    }

    var viewport = mainSlider.querySelector('.flickity-viewport');
    if (!viewport) return;

    var cellCount = flickityInstance.cells.length;
    if (cellCount <= 1) return;

    var dotsContainer = document.createElement('ol');
    dotsContainer.className = 'flickity-page-dots';

    for (var i = 0; i < cellCount; i++) {
      var dot = document.createElement('li');
      dot.className = 'dot';
      dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
      dot.addEventListener('click', function(index) {
        return function() {
          if (flickityInstance) {
            flickityInstance.select(index, false, true);
          }
        };
      }(i));
      dotsContainer.appendChild(dot);
    }

    var firstDot = dotsContainer.querySelector('.dot');
    if (firstDot) {
      firstDot.classList.add('is-selected');
    }

    flickityInstance.on('change', function(index) {
      var dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach(function(dot, i) {
        if (i === index) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
    });

    viewport.parentNode.insertBefore(dotsContainer, viewport.nextSibling);
  }

  return {
    filterByVariant: filterByVariant,
    initialize: initializeSlider,
    getState: updateSliderState,
    getCurrentImageId: getCurrentImageId,
    isInitializing: function() {
      return isInitializingSlider;
    }
  };
})();